import type {
  EditAsideWebFacetsPlaceholder,
  FilterableEditComponent,
} from '@nodeTypeConfig/configTypes';
import { proWebFacetAncestorTypes } from './proWebFacetAncestorTypes';

export const webFacetsPlaceHolderComponent: EditAsideWebFacetsPlaceholder = {
  component: 'webFacetsPlaceHolder',
  reactComponent: 'AsideWebFacetPlaceHolder',
  label: 'Facetten',
  noChangeMessage: true,
};

export const proWebFacetPlaceHolderComponent: FilterableEditComponent = {
  ...webFacetsPlaceHolderComponent,
  showInAncestorTypes: proWebFacetAncestorTypes,
};
